module.exports = __webpack_public_path__ + "img/messenger.4116a867.svg";